import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Ruler, ShieldCheck, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
import { site } from '../data/site';
const marks = [{
  icon: Ruler,
  label: 'Templated & laser-set'
}, {
  icon: ShieldCheck,
  label: 'Insured & warrantied'
}, {
  icon: Sparkles,
  label: 'Immaculate finish'
}];
export function Hero() {
  return <section id="top" className="relative isolate overflow-hidden bg-ink pt-20 text-ivory" data-id="element-95" data-mp="12a0j75mcfqrz">
      <img src="https://cdn.magicpatterns.com/uploads/fuVwiSsYZnzcZ8geDD1YQb/image.png" alt="" aria-hidden="true" width={1536} height={2048} loading="eager" decoding="async" className="absolute inset-0 h-full w-full object-cover opacity-[0.28]" data-id="element-96" data-mp="x9uqrn89208u" />
      <div className="absolute inset-0 bg-ink/70" aria-hidden="true" data-id="element-97" data-mp="3d2lb3gldnd2t" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-ink to-transparent" aria-hidden="true" data-id="element-98" data-mp="382p73hcojln9" />

      <div className="relative mx-auto grid max-w-[1400px] gap-16 px-6 py-24 lg:grid-cols-[1.15fr_0.85fr] lg:items-end lg:px-10 lg:py-32" data-id="element-99" data-mp="3j9u06x1wdkkr">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-100" data-mp="3o59c3jgch6ej">
          <div className="flex items-center gap-4" data-id="element-101" data-mp="3e7l802wummjp">
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-brass-light" data-id="element-102" data-mp="30hrgfctylo6a">
              {site.serviceArea}
            </span>
            <span className="h-px w-24 rule-brass" aria-hidden="true" data-id="element-103" data-mp="35aucbrm7l9pn" />
          </div>

          <h1 className="mt-8 font-display text-[13vw] leading-[0.86] tracking-tight sm:text-6xl lg:text-[5.6rem]" data-id="element-104" data-mp="2qlofuber9xlg">
            The details
            <br data-id="element-105" data-mp="2hjf6vpz4yca6" />
            <span className="italic text-brass-light" data-id="element-106" data-mp="2hix0i0irehoj">everyone</span> notices.
          </h1>

          <p className="mt-8 max-w-xl text-lg leading-relaxed text-ivory/70" data-id="element-107" data-mp="2lla5gmpombk9">
            Hardware Extraordinaire is a white-glove installation atelier. We select, supply, and set
            the pieces that finish a home — pulls, locks, mirrors, drapery, televisions, shelving —
            with the precision the rest of the house deserves.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-108" data-mp="ia5jsznr2lv8">
            <Button asChild className="h-14 rounded-none bg-brass px-8 font-mono text-[11px] uppercase tracking-[0.22em] text-ink hover:bg-brass-light" data-id="element-109" data-mp="degdmdh866py">
              <a href="#contact" data-id="element-110" data-mp="16345wt0e5wd0">
                Request a consultation
                <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="1126ncfbgz0az" />
              </a>
            </Button>
            <Button asChild variant="outline" className="h-14 rounded-none border-ivory/25 bg-transparent px-8 font-mono text-[11px] uppercase tracking-[0.22em] text-ivory hover:bg-ivory hover:text-ink" data-id="element-112" data-mp="x1w6g7m52phc">
              <a href="#services" data-id="element-113" data-mp="3htpzbveggqo1">See what we install</a>
            </Button>
          </div>

          <ul className="mt-12 flex flex-wrap gap-x-10 gap-y-4" data-id="element-114" data-mp="1x7hv3bmtnyzt">
            {marks.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-3 text-sm text-ivory/60" data-id="element-115" data-mp="26a99nkazvavo">
                <Icon className="h-4 w-4 text-brass" aria-hidden="true" data-id="element-116" data-mp="2b0pmb26zqsgz" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 32
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-117" data-mp="2fzarlg13o2ca">
          <div className="relative border border-brass/30 p-3" data-id="element-118" data-mp="2oyo1g9t4ysxj">
            <img src="https://cdn.magicpatterns.com/uploads/c9dDJtjnMZvEYhPN5oodMq/image.png" alt="Greige inset cabinetry with unlacquered brass knobs, pulls, and bridge faucet" width={1536} height={2048} loading="eager" decoding="async" className="h-[420px] w-full object-cover lg:h-[560px]" data-id="element-119" data-mp="2tz1xethgqcf7" />
            <div className="absolute -bottom-px -right-px bg-brass px-5 py-3" data-id="element-120" data-mp="3vh5jg58rl46o">
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink" data-id="element-121" data-mp="e8in9rv2qrb8">
                Unlacquered brass · Tarrytown
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}